/* unplugin-vue-components disabled */import script from "./RoleGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleGenerator.vue?vue&type=script&setup=true&lang=js"

import "./RoleGenerator.vue?vue&type=style&index=0&id=485ed8dd&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485ed8dd"]])

export default __exports__